import React, { useState, useEffect } from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import { FlatList } from 'react-native-gesture-handler';
import { SearchBar } from 'react-native-elements';
import FriendItem from '../friendItem';
import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style.js';
import { AddFriendPopUp } from '../addFriendPopUp';
import { baseUrl } from '../../constants/baseUrl';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  addFriendsContainer: {
    height: 60,
    display: 'flex',
  },
  buttonContainer: {
    maxHeight: 60,
    marginRight: theme.CONTAINER_MARGIN,
    marginLeft: theme.CONTAINER_MARGIN,
  },
  button: {
    width: '100%',
    height: '100%',
    display: 'flex',
    textAlign: 'center',
    lineHeight: 60,
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: theme.FONT_SIZE_HEADLINE,
    fontWeight: theme.FONT_WEIGHT_BOLD,
    color: theme.GREEN_WARM_COLOR,
    borderRadius: theme.BUTTON_BIG_BORDER_RADIUS,
  },
  header: {
    flexDirection: 'row-reverse',
    backgroundColor: theme.WHITE_COLOR,
  },
  alphabet: {
    color: theme.GREEN_WARM_COLOR,
    fontWeight: 'bold',
    paddingTop: 20,
    paddingBottom: 10,
    flex: 1,
  },
  usersListContainer: {
    flex: 1,
  },
  usersList: {
    flexGrow: 1,
    overflow: 'hidden',
  },
});

export const AddFriend = ({ callback, showAddFriend, text, currentUser, onFetch }) => {
  const [searchValue, setSearchValue] = useState('');
  const [turtletUserList, setTurtletUserList] = useState([]);
  const [allUsersList, setAllUsersList] = useState([]);

  async function fetchData() {
    try {
      const response = await onFetch({
        url: `${baseUrl}user`,
        method: 'GET',
      });
      const body = await response.json();
      switch (response.status) {
        case 201:
        case 200:
          setAllUsersList(body);
          break;
        default:
      }
    } catch (e) {
      // error -> do nothing
    }
  }

  useEffect(() => {
    fetchData();
  }, [searchValue]);

  function friendRequestSent(addedContact) {
    const addedContactIndex = allUsersList.findIndex((user) => user.email === addedContact.email);
    const newFriendList = allUsersList;
    newFriendList[addedContactIndex].requestSent = true;
    setAllUsersList(newFriendList);
  }

  async function getRelationhipStatus(searchedUsers) {
    const userIDs = [];
    searchedUsers.forEach((user) => {
      if (!user.header) {
        userIDs.push(user.id);
      }
    });

    const postObj = {
      ownId: currentUser.user.id,
      ids: userIDs,
    };

    const response = await onFetch({
      url: `${baseUrl}friendship/status`,
      method: 'POST',
      body: JSON.stringify(postObj),
    });

    const sendRequest = await response.json();
    const searchedUsersWithRelations = searchedUsers;

    switch (response.status) {
      case 201:
      case 200:
        // eslint-disable-next-line no-plusplus
        for (let i = 1; i < searchedUsersWithRelations.length; i++) {
          searchedUsersWithRelations[i].relationStatus = sendRequest[i - 1].name;
        }

        setTurtletUserList(searchedUsersWithRelations);
        break;
      default:
    }
  }

  function onSearchTermChanged(searchTerm) {
    setSearchValue(searchTerm);
    setTurtletUserList(null);
    const searchTermEdited = searchTerm.toLowerCase().split(' ').join('');
    if (searchTermEdited.length > 0) {
      // eslint-disable-next-line arrow-body-style
      const searchedList = allUsersList.filter((friend) => {
        let friendNames = friend.firstname + friend.lastname + friend.nickname;
        friendNames = friendNames.toLowerCase();
        return friendNames.includes(searchTermEdited);
      });
      if (searchedList.length < 1) {
        searchedList.push({
          firstname: 'No matches',
          header: true,
        });
      } else {
        searchedList.unshift({
          firstname: 'Top name matches',
          header: true,
        });
      }
      getRelationhipStatus(searchedList);
    }
  }
  if (showAddFriend) {
    return (
      <View style={styles.container}>
        <TouchableOpacity testID="button" onPress={callback} style={styles.addFriendsContainer}>
          <CustomText style={styles.button}>{text}</CustomText>
        </TouchableOpacity>
        <View style={styles.usersListContainer}>
          <SearchBar
            round
            platform="default"
            lightTheme
            containerStyle={{
              backgroundColor: 'transparent',
              borderTopWidth: 0,
              borderBottomWidth: 0,
              paddingLeft: 0,
            }}
            searchIcon={{ size: 24 }}
            onChangeText={(searchTerm) => onSearchTermChanged(searchTerm)}
            placeholder="Search for friends"
            value={searchValue}
          />
          <View style={styles.usersListContainer}>
            <FlatList
              style={styles.users}
              contentContainerStyle={styles.usersList}
              data={turtletUserList}
              showsVerticalScrollIndicator={false}
              keyExtractor={(item, index) => index.toString()}
              // eslint-disable-next-line consistent-return
              renderItem={({ item }) => {
                if (item.header) {
                  return (
                    <View>
                      <View style={styles.header}>
                        <CustomText style={styles.alphabet}>{item.firstname}</CustomText>
                      </View>
                    </View>
                  );
                }
                if (!item.header) {
                  if (!item.requestSent) {
                    return (
                      <FriendItem
                        friend={item}
                        addAsFriend
                        relationStatus={item.relationStatus}
                        callbackRequestSent={friendRequestSent}
                      />
                    );
                  }
                  return <FriendItem friend={item} addAsFriend requestSent />;
                }
              }}
            />
          </View>
        </View>
        <AddFriendPopUp />
      </View>
    );
  }
  return (
    <View style={[styles.buttonContainer]}>
      <TouchableOpacity onPress={callback} style={styles.addFriendsContainer} testID="button">
        <CustomText style={styles.button}>{text}</CustomText>
      </TouchableOpacity>
    </View>
  );
};

export default AddFriend;
